import { render } from 'react-dom';
import 'styles/global.scss';
import 'utils/i18n';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/Store';
import { initConfigApp, isPWA } from './utils/common';
import InstallOverlay from './components/overlay/InstallOverlay';
import ErrorBoundary from './components/common/ErrorBoundary';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then((registration) => {
      console.log('✅ Service Worker registered:', registration);
    })
    .catch((error) => {
      console.error('❌ Service Worker registration failed:', error);
    });
}

const bootstrap = async () => {
  try {
    //NOTE: Phải chờ config (tên app, logo) trước khi render để tránh nháy dữ liệu rỗng
    await initConfigApp();
  } catch (error) {
    //NOTE: Lỗi ở bước này xảy ra trước khi React render nên ErrorBoundary không bắt được,
    //vẫn phải render tiếp để người dùng thấy màn hình thay vì trang trắng
    console.error('Init config failed:', error);
  }

  render(
    <ErrorBoundary>
      <BrowserRouter>
        <Provider store={store}>{isPWA() ? <App /> : <InstallOverlay />}</Provider>
      </BrowserRouter>
    </ErrorBoundary>,
    document.getElementById('root'),
  );
};

bootstrap();
